// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__Py8cz","Regular":"Button_Regular__3KcMX","Primary":"Button_Primary__21aot"};